// Tu clase de geolocalización
export default class GeolocationDBDetector {
  constructor() {
    this.baseURL = 'https://us-central1-functions-358315.cloudfunctions.net/location-request';
  }

  async obtenerUbicacion() {
    try {
      const cached = this.obtenerCache();
      if (cached) return cached;

      const response = await fetch(this.baseURL);
      const data = await response.json();

      const location = {
        state: data.stateCode,
        city: data.city,
        country: data.countryCode,
        timestamp: Date.now(),
        servicio: 'API pw'
      };

      this.guardarCache(location);
      return location;
    } catch (error) {
      console.error('Error Geolocation-DB:', error);
      return null;
    }
  }

  obtenerCache() {
    try {
      const cached = localStorage.getItem('geodb_location');
      if (!cached) return null;

      const data = JSON.parse(cached);
      const CACHE_DURATION = 6 * 60 * 60 * 1000; // 6 horas

      if (Date.now() - data.timestamp < CACHE_DURATION) {
        return data;
      } else {
        localStorage.removeItem('geodb_location');
        return null;
      }
    } catch (error) {
      return null;
    }
  }

  guardarCache(ubicacion) {
    try {
      localStorage.setItem('geodb_location', JSON.stringify(ubicacion));
    } catch (error) {
      console.log('Error saving cache');
    }
  }
}
